export const BILLING_CADENCES = ['monthly'] as const;

export type BillingCadence = 'monthly';

/** Constant for the Pay As You Go plan code. Import this instead of using the raw string. */
export const PLAN_CODE_PAYG = 'pay_as_you_go' as const;

export const OVERAGE_RATE_PER_MINUTE = 0.05 as const;
export const PAYG_RATE_PER_MINUTE = 0.03 as const;

export const BILLING_PLANS = {
  individual: {
    code: 'individual',
    label: 'Individual',
    monthlyPrice: 14,
    minutesIncluded: 600,
  },
  enterprise_1: {
    code: 'enterprise_1',
    label: 'Enterprise 1-agent',
    monthlyPrice: 59,
    minutesIncluded: 1200,
  },
  enterprise_5: {
    code: 'enterprise_5',
    label: 'Enterprise 5-agent',
    monthlyPrice: 249,
    minutesIncluded: 3000,
  },
} as const;

export type BillingPlanCode = keyof typeof BILLING_PLANS | typeof PLAN_CODE_PAYG;

export const PLAN_CODE_VALUES = Object.keys(BILLING_PLANS) as (keyof typeof BILLING_PLANS)[];

export type BillingStatus = 'active' | 'past_due' | 'canceled';

export interface EntitlementProjection {
  userId: string;
  organizationId?: string;
  provider: 'paddle' | 'polar';
  providerSubscriptionId: string;
  planCode: BillingPlanCode;
  cadence: BillingCadence;
  status: BillingStatus;
  cancelAtPeriodEnd: boolean;
  currentPeriodStart: string | null;
  currentPeriodEnd: string | null;
  lastEventId: string | null;
  lastEventOccurredAt: string | null;
}

export interface BillingEvent {
  provider: 'paddle' | 'polar';
  externalEventId: string;
  occurredAt: string;
  type: 'subscription_created' | 'subscription_updated' | 'subscription_canceled';
  customerId: string;
  subscriptionId: string;
  userId: string;
  organizationId?: string;
  planCode: BillingPlanCode;
  cadence: BillingCadence;
  status: BillingStatus;
  cancelAtPeriodEnd: boolean;
  currentPeriodStart: string | null;
  currentPeriodEnd: string | null;
}
